jQuery.timeago.settings.cutoff = 1000*60*60*24

Visualiziation = class
  constructor: (@chart, @data, container) ->
    # debugger
    # Calculate Max
    @max = d3.max(@data, (d) => return +@data_mapping(d) )
    # Size to width
    @width = $(container).width()
  data_mapping: (d) -> d.doc_count
  date_label_mapping: (d) -> d3.time.format("%Y-%m-%d")(new Date(d.key))
  build_scale: (min, max, width) ->
    d3.scale.linear().domain([
      min, max
    ]).range([
      min, width
    ])

ByDayVisualiziation = class extends Visualiziation
  build: ->
    barHeight = 20
    height    = @data.length * barHeight + 20
    x         = @build_scale(0, @max, @width)
    @chart.attr("width", @width).attr("height", height)
   
    #
    # Space the bars
    bar = @chart.selectAll("g").data(@data).enter().append("g").attr("transform", (d, i) ->
      "translate(0," + i * barHeight + ")"
    )
    #
    # Create the X axis
    xAxis = d3.svg.axis()
        .scale(x)
    #
    # Setup colour scale
    color_scale = d3.scale.linear()
      .domain([0, @max])
      .range(["steelblue", "grey"])
    #
    # Build a rectangle based on d.count
    bar.append("rect")
      .attr("width", (d) => x(@data_mapping(d)) )
      .attr("height", barHeight - 1)
      .attr("fill", (d) => color_scale(@data_mapping(d)))
    #
    # Label bars
    bar.append("text").attr("x", 5).attr("y", barHeight / 2).attr("dy", ".35em").text( (d) => @date_label_mapping(d) )
    xAxisGroup = @chart.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + ( height - 20 ) + ")")
      .call(xAxis)

PieChartVisualiziation = class extends Visualiziation
  build: ->
    @tuples = []
    console.log $(@chart)
    console.log @data

    for i in @data
      @tuples.push [ i.key, i.doc_count ]

    @chart.highcharts(
      chart:
        plotBorderWidth: null
        plotShadow: false
        height: 300

      title: null
      tooltip:
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"

      plotOptions:
        pie:
          allowPointSelect: true
          cursor: "pointer"
          center: ['50%', '75%']
          dataLabels:
            enabled: true
            format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            style:
              color: (Highcharts.theme and Highcharts.theme.contrastTextColor) or "black"
      series: [
        type: "pie"
        name: "User Activity"
        innerSize: '15%'
        data: @tuples
      ]
    )
    return


ready = ->
  $('.chosen-select').chosen
    allow_single_deselect: true
    no_results_text: "No results matched"
    width: "200px"

  $("form#charts").on "submit", (e) ->
    e.preventDefault()
    form        = $(this)
    data        = JSON.stringify $("form#search").serializeArray()
    form.find("input#data").val data
    this.submit()

  if $("#chart_by_day").length > 0
    chart = new ByDayVisualiziation(d3.select("#chart_by_day"), by_date_json, "#charts-container")
    chart.build()

  if $("#chart_by_email").length > 0
    chart = new PieChartVisualiziation($("#chart_by_email"), by_email_json, "#charts-container")
    chart.build()
  return

export default
  init: ready



// WEBPACK FOOTER //
// ./app/javascript/packs/loggerator.coffee